import React, { memo } from 'react';
import PropTypes from 'prop-types';

import { compose } from 'redux';
import { connect } from 'react-redux';

import { useInjectReducer } from 'utils/injectReducer';
import { useInjectSaga } from 'utils/injectSaga';

import saga from './saga';
import reducer from './reducer';

export function Orders({ children }) {
  useInjectSaga({ key: 'reportsOrders', saga });
  useInjectReducer({ key: 'reportsOrders', reducer });

  return React.Children.only(children);
}

Orders.propTypes = {
  children: PropTypes.element,
};

const withConnect = connect();

export { default as withReportsOrders } from './withReportsOrders';
export default compose(withConnect, memo)(Orders);
